import type { ReactNode } from 'react';
import { useAuth } from '../auth/AuthProvider';
import { NoTenantPage } from '../pages/NoTenantPage';

/**
 * RequireTenant — UX GATING ONLY, never the access boundary. The server
 * enforces tenant isolation (frontend-architecture R13 / security SR5).
 * An authenticated user with no tenantSlug claim (e.g. not affiliated with
 * any organisation) is shown the no-tenant error page with a Logout action
 * — never the app home. Compose INSIDE <RequireAuth> so this only runs for
 * an already-authenticated user.
 */
export function RequireTenant({ children }: { children: ReactNode }) {
  const { tenantSlug } = useAuth();
  if (tenantSlug === undefined) {
    return <NoTenantPage />;
  }
  return <>{children}</>;
}
RequireTenant.displayName = 'RequireTenant';
